import { CustomRuleGroup, Filter } from '../../models/filter-models';
import { SettingsService } from '../../services/settings.service';

function anyRuleHasLabel(groups?: CustomRuleGroup[]): boolean {
  if (!groups?.length) return false;
  for (const g of groups) {
    for (const r of g.rules ?? []) {
      if (r.label?.trim()) return true;
    }
  }
  return false;
}

export function isCustomRuleLabelsEnabled(filter?: Filter): boolean {
  if (SettingsService.instance.enableCustomRuleLabels()) return true;
  if (filter && (anyRuleHasLabel(filter.customRuleGroups) || anyRuleHasLabel(filter.customCosmeticRuleGroups))) return true;
  return false;
}

export function setCustomRuleLabelsEnabled(enabled: boolean): void {
  SettingsService.instance.setEnableCustomRuleLabels(enabled);
}

export function shouldShowEnableCustomRuleLabelsLink(filter: Filter): boolean {
  return !isCustomRuleLabelsEnabled(filter);
}
